const binding = { modules: {}, dataActions: {} };

    (binding.modules['hei-locale-redirect'] = {
        c: () => require('partner/modules/hei-locale-redirect/hei-locale-redirect.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'hei-locale-redirect',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/hei-locale-redirect'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|hei-locale-redirect|hei-locale-redirect'] = {
                c: () => require('partner/modules/hei-locale-redirect/hei-locale-redirect.view.tsx'),
                cn: '__local__-__local__-hei-locale-redirect'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };